/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').controller('TestDatasInjectorCtrl', ["$scope",
    function ($scope) {
        var now = new Date();
        var deb = new Date();
        deb.setTime(deb.getTime() - (7 * 24 * 60 * 60 * 1000));

        $scope.mapParameters = [];

        $scope.mapParameters['TestStatInjector'] = [
            {
                name: "companyCode",
                label: "Code entreprise",
                value: "sdf",
                type: 'text',
                required: false
            },
            {
                name: "dateDeb",
                label: "Date de début",
                value: deb,
                type: 'date',
                required: true
            },
            {
                name: "dateFin",
                label: "Date de fin",
                value: now,
                type: 'date',
                required: true
            },
            {
                name: "populeConfig",
                label: "populeConfig",
                value: true,
                type: 'text',
                required: true
            }
        ];

        $scope.actionEnCours = false;
        $scope.actionTerminee = false;

        $scope.lancer = function ($event) {
            $scope.actionEnCours = true;
            $scope.actionTerminee = false;

            $("#myTable").empty();
            $scope.searchPb(0);

        };

        $scope.searchPb = function (offset, companyCode) {
            var parametersCleaner = "";
            for (var i = 0; i < $scope.mapParameters[$scope.injector].length; i++) {
                parametersCleaner += "&";
                if ($scope.mapParameters[$scope.injector][i].type != 'date') {
                    parametersCleaner += $scope.mapParameters[$scope.injector][i].name + "=" + $scope.mapParameters[$scope.injector][i].value;
                } else {
                    parametersCleaner += $scope.mapParameters[$scope.injector][i].name + "=" + $scope.getDateString($scope.mapParameters[$scope.injector][i].value);
                }
            }

            $.ajax({
                url: "/flexyTest/injector?type=" + $scope.injector + parametersCleaner,
                success: function (result) {
                    //var datas = jQuery.parseJSON(result );
                    var datas = result;
                    console.info(datas);
                    if (datas && datas.listeResult && datas.listeResult.length != 0) {
                        $scope.addLines(datas.listeResult);
                    }
                    if (datas.parameters) {
                        $scope.addParameters(datas.parameters);
                    }
                }
            });
        }

        $scope.addLines = function (datas) {
            var lignes = "";
            for (var i = 0; i < datas.length; i++) {
                if (datas[i].ccompanyStatus != "canceled" && datas[i].ccompanyStatus != "billingBlocked" && datas[i].ccompanyStatus != "blocked" && datas[i].ccompanyStatus != "internalTest" && datas[i].ccompanyStatus != "model") {
                    lignes += "<tr style='background-color:" + datas[i].backgroundColor + "'>";
                    lignes += "<td>" + datas[i].message + "</td>";
                    //lignes += "<td>" + datas[i].userLogin + "</td>";
                    //lignes += "<td><a href='/fxbAdmin/" + datas[i].companyCode + "' target='_blank'><button class='btn btn-save'><i class='fal fa-sign-in'></i>&nbsp;Page de connexion</button></a></td>";
                    //lignes += "<td><input type='button' value='Réparer le salon' onclick='repareOne(\"" + datas[i].companyCode + "\")'></input></td>";
                    lignes += "</tr>";
                }
            }
            $("#myTable").append(lignes);

        }

        $scope.addParameters = function (parameters) {
            var lignes = "";
            for (var i = 0; i < parameters.length; i++) {
                lignes += "<tr><td>" + parameters[i].name + "</td><td>" + parameters[i].value + "</td></tr>";
            }

            $("#myParameters").empty();
            $("#myParameters").append(lignes);

        }

        $scope.getDateString = function (dateValue) {

            var today = dateValue;
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!

            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd
            }
            if (mm < 10) {
                mm = '0' + mm
            }
            today = yyyy + '-' + mm + '-' + dd;
            return today;
        }
    }]);




// WEBPACK FOOTER //
// ./js/controllers/pro/testDatasInjector/TestDatasInjectorCtrl.js